/**
 * @flow
 * @relayHash 540e90123b554586a6fdb97ac6d01cbb
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Metrics_pipeline$ref = any;
export type PipelineVisibility = "PRIVATE" | "PUBLIC" | "%future added value";
export type PipelineUpdateInput = {
  clientMutationId?: ?string,
  id: string,
  name?: ?string,
  description?: ?string,
  visibility?: ?PipelineVisibility,
  repository?: ?PipelineRepositoryInput,
  steps?: ?PipelineStepsInput,
  defaultBranch?: ?string,
  nextBuildNumber?: ?number,
  skipIntermediateBuilds?: ?boolean,
  skipIntermediateBuildsBranchFilter?: ?string,
  cancelIntermediateBuilds?: ?boolean,
  cancelIntermediateBuildsBranchFilter?: ?string,
  clusterId?: ?string,
};
export type PipelineRepositoryInput = {
  url: string
};
export type PipelineStepsInput = {
  yaml: string
};
export type BranchSettingsDialogPipelineUpdateMutationVariables = {|
  input: PipelineUpdateInput
|};
export type BranchSettingsDialogPipelineUpdateMutationResponse = {|
  +pipelineUpdate: ?{|
    +pipeline: {|
      +defaultBranch: ?string,
      +$fragmentRefs: Metrics_pipeline$ref,
    |}
  |}
|};
export type BranchSettingsDialogPipelineUpdateMutation = {|
  variables: BranchSettingsDialogPipelineUpdateMutationVariables,
  response: BranchSettingsDialogPipelineUpdateMutationResponse,
|};
*/


/*
mutation BranchSettingsDialogPipelineUpdateMutation(
  $input: PipelineUpdateInput!
) {
  pipelineUpdate(input: $input) {
    pipeline {
      defaultBranch
      ...Metrics_pipeline
      id
    }
  }
}

fragment Metrics_pipeline on Pipeline {
  metrics(first: 6) {
    edges {
      node {
        label
        ...Metric_metric
        id
      }
    }
  }
}

fragment Metric_metric on PipelineMetric {
  label
  value
  url
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "PipelineUpdateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "PipelineUpdateInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "defaultBranch",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "BranchSettingsDialogPipelineUpdateMutation",
  "id": null,
  "text": "mutation BranchSettingsDialogPipelineUpdateMutation(\n  $input: PipelineUpdateInput!\n) {\n  pipelineUpdate(input: $input) {\n    pipeline {\n      defaultBranch\n      ...Metrics_pipeline\n      id\n    }\n  }\n}\n\nfragment Metrics_pipeline on Pipeline {\n  metrics(first: 6) {\n    edges {\n      node {\n        label\n        ...Metric_metric\n        id\n      }\n    }\n  }\n}\n\nfragment Metric_metric on PipelineMetric {\n  label\n  value\n  url\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "BranchSettingsDialogPipelineUpdateMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "pipelineUpdate",
        "storageKey": null,
        "args": v1,
        "concreteType": "PipelineUpdatePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pipeline",
            "storageKey": null,
            "args": null,
            "concreteType": "Pipeline",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "FragmentSpread",
                "name": "Metrics_pipeline",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "BranchSettingsDialogPipelineUpdateMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "pipelineUpdate",
        "storageKey": null,
        "args": v1,
        "concreteType": "PipelineUpdatePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pipeline",
            "storageKey": null,
            "args": null,
            "concreteType": "Pipeline",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "metrics",
                "storageKey": "metrics(first:6)",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 6,
                    "type": "Int"
                  }
                ],
                "concreteType": "PipelineMetricConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PipelineMetricEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PipelineMetric",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "label",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "value",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "url",
                            "args": null,
                            "storageKey": null
                          },
                          v3
                        ]
                      }
                    ]
                  }
                ]
              },
              v3
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '69841a610b87ec003e17f35fae8c8a05';
module.exports = node;
